FormEventEmitter = function () {};
heir.inherit(FormEventEmitter, AppEventEmitter);
// noinspection JSCheckFunctionSignatures
FormEventEmitter.prototype.addListener = function (name, action, listener) {
    AppEventEmitter.prototype.addListener.call(this, (name + '.' + action), listener);
};
// noinspection JSCheckFunctionSignatures
FormEventEmitter.prototype.emitEvent = function (name, action, args) {
    name = typeof name === 'object' ? $(name).data('name') : name;
    args = args || {};
    $.extend(args, { e: $('#form_' + name.replace(/\./g, '_')), name: name });
    AppEventEmitter.prototype.emitEvent.call(this, ('*' + '.' + action), [ args ]);
    for (var i = 1; i <= name.split('.').length; i++) {
        AppEventEmitter.prototype.emitEvent.call(
            this,
            (name.split('.', i).join('.') + '.' + action),
            [ args ]
        );
    }
};

app.form = new FormEventEmitter();
app.form.AJAX_BEFORE_SEND = 'ajax_before_send';
app.form.AJAX_DONE = 'ajax_done';
app.form.AJAX_FAIL = 'ajax_fail';
app.form.AJAX_ALWAYS_BEFORE = 'ajax_always_before';
app.form.AJAX_ALWAYS_AFTER = 'ajax_always_after';
app.form.SUBMIT = 'submit';
app.form.RESET = 'reset';
app.form.BLOCK_UI = 'block_ui';
app.form.UNBLOCK_UI = 'unblock_ui';

app.form.on('*', app.form.SUBMIT, function (form) {
    if (form.e.data('disabled')) {
        return false;
    }
    $.ajax($.extend(true, {
        url: form.e.attr('action'),
        method: form.e.attr('method'),
        data: form.e.serialize(),
        beforeSend: function (jqXHR, settings) {
            app.form.trigger(form.name, app.form.AJAX_BEFORE_SEND, {
                jqXHR: jqXHR,
                settings: settings
            });
        }
    }, form.settings)).always(function (data_jqXHR, textStatus, jqXHR_errorThrown) {
        if (textStatus === 'success') {
            app.form.trigger(form.name, app.form.AJAX_ALWAYS_BEFORE, {
                data: data_jqXHR,
                textStatus: textStatus,
                jqXHR: jqXHR_errorThrown
            });
        } else {
            app.form.trigger(form.name, app.form.AJAX_ALWAYS_BEFORE, {
                jqXHR: data_jqXHR,
                textStatus: textStatus,
                errorThrown: jqXHR_errorThrown
            });
        }
    }).done(function (data, textStatus, jqXHR) {
        app.form.trigger(form.name, app.form.AJAX_DONE, {
            data: data,
            textStatus: textStatus,
            jqXHR: jqXHR
        });
    }).fail(function (jqXHR, textStatus, errorThrown) {
        app.form.trigger(form.name, app.form.AJAX_FAIL, {
            jqXHR: jqXHR,
            textStatus: textStatus,
            errorThrown: errorThrown
        });
    }).always(function (data_jqXHR, textStatus, jqXHR_errorThrown) {
        if (textStatus === 'success') {
            app.form.trigger(form.name, app.form.AJAX_ALWAYS_AFTER, {
                data: data_jqXHR,
                textStatus: textStatus,
                jqXHR: jqXHR_errorThrown
            });
        } else {
            app.form.trigger(form.name, app.form.AJAX_ALWAYS_AFTER, {
                jqXHR: data_jqXHR,
                textStatus: textStatus,
                errorThrown: jqXHR_errorThrown
            });
        }
    });
});
{
    app.form.on('*', app.form.AJAX_BEFORE_SEND, function (form) {
        form.e.data('disabled', true);
        app.form.trigger(form.name, app.form.BLOCK_UI);
    });
    app.form.on('*', app.form.AJAX_ALWAYS_BEFORE, function (form) {
        form.e
            .find('.has-error')
            .removeClass('has-error')
            .end()
            .find('[data-get-error]')
            .html('')
            .end()
            .find('.form-control, .form-check-input, .select2-container')
            .removeClass('is-invalid')
            .end()
            .find('.help-block')
            .removeClass('invalid-feedback');
    });
    app.form.on('*', app.form.AJAX_FAIL, function (form) {
        if ('responseJSON' in form.jqXHR && form.jqXHR['responseJSON']['errors']) {
            $.each(form.jqXHR['responseJSON']['errors'], function (name, error) {
                var group;
                if ($('#' + name.replace(/\./g, '_')).length === 1) {
                    group = $('#' + name.replace(/\./g, '_')).closest('[data-may-error]');
                } else {
                    group = $('#' + name.replace(/\./g, '_'), form.e).closest('[data-may-error]');
                }
                if (group.length) {
                    var names = group.data('may-error');
                    if (!(names instanceof Array)) {
                        names = names.split(',');
                    }
                    if ($.inArray(name, names) !== -1) {
                        group
                            .addClass('has-error')
                            .find('[data-get-error="' + name + '"]')
                            .html(error);
                        group
                            .find('.form-control, .form-check-input, .select2-container')
                            .addClass('is-invalid')
                            .end()
                            .find('.help-block')
                            .addClass('invalid-feedback');
                    }
                } else {
                    $('[data-may-error]', form.e).each(function () {
                        var group = $(this);
                        var names = group.data('may-error');
                        if (!(names instanceof Array)) {
                            names = names.split(',');
                        }
                        if ($.inArray(name, names) !== -1) {
                            group
                                .addClass('has-error')
                                .find('[data-get-error="' + name + '"]')
                                .html(error);
                            group
                                .find('.form-control, .form-check-input, .select2-container')
                                .addClass('is-invalid')
                                .end()
                                .find('.help-block')
                                .addClass('invalid-feedback');
                        }
                    });
                }
            });
        }
    });
    app.form.on('*', app.form.AJAX_ALWAYS_AFTER, function (form) {
        form.e.data('disabled', false);
        app.form.trigger(form.name, app.form.UNBLOCK_UI);
    });
}

app.form.on('*', app.form.RESET, function (form) {
    form.e[0].reset();
    // form.e.find('.btn-group[data-toggle="buttons"] > .active').removeClass('active');
    form.e.find('.select2').select2('val', '');
});

app.form.on('*', app.form.BLOCK_UI, function (form) {
    app.plugin.trigger(app.plugin.UI_BLOCK, {
        e: form.e.closest('.widget')
    });
});

app.form.on('*', app.form.UNBLOCK_UI, function (form) {
    app.plugin.trigger(app.plugin.UI_UNBLOCK, {
        e: form.e.closest('.widget')
    });
});
